@import "~swiper/swiper.scss";
@import "~swiper/modules/navigation.scss";
@import "~swiper/modules/pagination.scss";
@import "~swiper/modules/effect-fade.scss";

$color-black: #101010;
$color-white: #ffffff;
$color-gray: #848484;
$color-overlay-gray: #DFE3E8;
$color-overlay-gray-lite: #F9FAFB;

@import "covet-pics-highlighted-slider-control.scss";

covet-pics-highlighted {
  box-sizing: border-box;
  display: block;
  width: 100%;
  position: relative;
  overflow: hidden;
  &.row {
    display: grid;
    grid-template-columns: repeat(3, calc(100% / 3 - var(--covet-pics-highlighted-padding-px) * 2 / 3));
    padding: var(--covet-pics-highlighted-padding-px);
    grid-gap: var(--covet-pics-highlighted-padding-px);
    @media only screen and (max-width : 799.98px) {
      padding: 0;
      grid-gap: 0;
      grid-template-columns: repeat(1, 100%);
    }
  }
  &.slider {
    height: 100vh;
    height: calc(var(--covet-pics-highlighted-window-height, 1vh) * 100);
    padding: var(--covet-pics-highlighted-padding);
    @media only screen and (max-width : 799.98px) {
      padding: 0;
    }
  }
  &.spotlight {
    height: 115vh; // TODO add min-height for case with large padding size to show correct pagination
    height: calc(var(--covet-pics-highlighted-window-height, 1vh) * 115);
    padding: var(--covet-pics-highlighted-padding);
    @media only screen and (max-width : 799.98px) {
      padding: 0;
      height: 100vh;
      height: calc(var(--covet-pics-highlighted-window-height, 1vh) * 100);
    }
  }

  h1, h2, h3, h4, h5, h6, p {
    margin-top: 0;
    margin-bottom: 16px;
    color: var(--covet-pics-highlighted-primary-color); // test color
  } 
  
  p {
    margin-top: 0;
    margin-bottom: 8px;
    color: var(--covet-pics-highlighted-secondary-color); // test color
  }

  .main-slider {
    width: 100%;
    overflow: hidden;
    position: relative;
    height: 100%;

    .page {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
    }

    .slide-noactive {
      opacity: 0;
      transform: translateY(-100%);
      pointer-events: none;
    }

    .slide-active {
      opacity: 1;
      .thumbnail .img-cover, .thumbnail .img-contain {
        transform: scale(1);
      }
      .thumbnail .thumbnail-carousel .swiper-slide .img-cover,
      .thumbnail .thumbnail-carousel .swiper-slide .img-contain {
        transform: scale(1);
      }
    }

    .leave {
      opacity: 0;
      transition: opacity 0.6s ease;
      &.fast {
        transition: opacity 0.3s ease;
      }
    }

    .leave-to {
      transform: translateY(-100%);
    }


    .before-enter {
      opacity: 0;
      transition: none;
      transform: none;
      z-index: 3;
      .thumbnail .img-cover, .thumbnail .img-contain {
        transform: scale(1.2);
      }
      .thumbnail .thumbnail-carousel .swiper-slide .img-cover,
      .thumbnail .thumbnail-carousel .swiper-slide .img-contain {
        transform: scale(1);
      }
    
      .thumbnail .thumbnail-carousel .swiper-slide.swiper-slide-active .img-cover,
      .thumbnail .thumbnail-carousel .swiper-slide.swiper-slide-active .img-contain {
        transform: scale(1.2);
      }
    }
    
    .enter {
      opacity: 1;
      transform: none;
      transition: opacity 0.6s ease;
      z-index: 3;
      .thumbnail .img-cover, .thumbnail .img-contain {
        transition: transform 0.6s ease;
        transform: scale(1);
      }

      .thumbnail .thumbnail-carousel .swiper-slide.swiper-slide-active .img-cover,
      .thumbnail .thumbnail-carousel .swiper-slide.swiper-slide-active .img-contain {
        transition: transform 0.6s ease;
        transform: scale(1);
      }
      &.fast {
        transition: opacity 0.3s ease;
        .thumbnail .img-cover, .thumbnail .img-contain {
          transition: transform 0.3s ease;
        }
        .thumbnail .thumbnail-carousel .swiper-slide.swiper-slide-active .img-cover,
        .thumbnail .thumbnail-carousel .swiper-slide.swiper-slide-active .img-contain {
          transition: transform 0.3s ease;
          transform: scale(1);
        }
      }
    }
  }
  
  .img-wrap {
    display: flex;
  }

  .img-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform-origin: center center;
  }

  .img-contain {
    object-position: 50% 50%;
    width: 100%;
    object-fit: cover;
    height: 100%;
    object-fit: contain;
  }

  .icon-arrow {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: center center;
    path {
      fill: var(--covet-pics-highlighted-primary-color);
    }
    &.rotate {
      transform: translate(-50%, -50%) rotate(180deg);
    }
  }

  .page-pagination {
    position: absolute;
    left: 50%;
    top: 60%;
    transform: translate(-50%, calc(298px - 80px + 24px));
    font-size: 14px;
    color: var(--covet-pics-highlighted-primary-color);
    line-height: 18px;
    letter-spacing: 0.5px;
    z-index: 10;
    @media only screen and (max-width : 799.98px) {
      top: auto;
      bottom: 0;
      transform: translate(-50%, calc(-10px - 8px));
      
    }
  }
}

@keyframes pulsate {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }

  100% {
    opacity: 1;
  }
}



